// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"355085c2","513":"067d47d8","703":"534a8299","787":"97a786da"}[chunkId] + ".chunk.js";
};